<script setup lang="ts">
import type { Button } from '@pkg/sanity-utils/types/button';
import { computed, type Component } from 'vue';

const props = defineProps<{
  block?: {
    _type: string;
    _key: string;
    variant: 'default' | 'center';
    buttons: Array<Button>;
  };
  config: {
    innerComponent?: Component;
  };
}>();

const data = computed(() => ({
  buttons: props.block?.buttons,
  variant: props.block?.variant,
}));

</script>

<template>
  <component :is="props.config?.innerComponent" v-bind="data"/>
</template>
